import { useFiltersDrawer } from '../../../shared/providers/FiltersDrawerContext';

import s from './MobileFiltersButton.module.css';

export const FiltersButton = (): JSX.Element => {
    const { openFiltersDrawer } = useFiltersDrawer();
    return (
        <button type="button" onClick={openFiltersDrawer} className={s.button}>
            <div />
            <div />
            <div />
        </button>
    );
};
